export default __webpack_public_path__ + "static/media/Hat of the Rippling Lake.f4ff1a0f.jpg";